import { render, staticRenderFns } from "./sh_SuccessOpenBookingTranslation.vue?vue&type=template&id=36ad2602&scoped=true&"
import script from "./sh_SuccessOpenBookingTranslation.vue?vue&type=script&lang=js&"
export * from "./sh_SuccessOpenBookingTranslation.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/open_booking_success_info.css?vue&type=style&index=0&id=36ad2602&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ad2602",
  null
  
)

export default component.exports